export const caseStudies = [
  {
    id: 1,
    industry: "SaaS",
    title: "Scaling outbound for a mid-market SaaS platform",
    description: "A refreshed data set and lead-scoring model turned a stagnant pipeline into a predictable engine.",
    results: [
      { label: "Leads", value: "+145%" },
      { label: "Conversion", value: "+82%" },
      { label: "Revenue", value: "+65%" },
    ],
    tone: "blue",
  },
  {
    id: 2,
    industry: "Healthcare",
    title: "Compliant account-based marketing for a med-tech brand",
    description: "Segmented, verified contact data let the sales team focus only on qualified health-system buyers.",
    results: [
      { label: "Qualified leads", value: "+96%" },
      { label: "Sales cycle", value: "-30%" },
      { label: "Pipeline value", value: "+58%" },
    ],
    tone: "violet",
  },
  {
    id: 3,
    industry: "Recruitment",
    title: "Building a repeatable candidate pipeline",
    description: "A structured sourcing and profiling process cut time-to-hire while raising candidate quality.",
    results: [
      { label: "Time-to-hire", value: "-38%" },
      { label: "Candidate quality", value: "+70%" },
      { label: "Retention", value: "+22%" },
    ],
    tone: "magenta",
  },
];
